module.exports = __webpack_public_path__ + "static/media/virusWtf.58b4731c.png";